<template>
  <!-- AppTooltip behaves very weird if element in scrollable
  element and the scrollable element is not relative positioned  -->
  <div
    :id="scrollContainerId"
    ref="scrollContainer"
    :style="`
      overflow-y:auto;
      position: relative;
      height:calc(100vh - ${topSpacing}px);`
    "
  >
    <slot />
  </div>
</template>
<script>
import _throttle from 'lodash/throttle'
import { provide } from '@vue/composition-api'

export default {
  data () {
    return {
      topSpacing: 0,
      scrollTop: 0,
    }
  },
  setup (props, { root }) {
    const scrollContainerId = `common-scroll-container-${root._uid}`
    provide('scrollContainer', `#${scrollContainerId}`)

    return {
      scrollContainerId,
    }
  },
  watch: {
    scrollTop (newPos, oldPos) {
      if ((newPos !== 0 && oldPos === 0) || (newPos === 0 && oldPos !== 0)) this.$emit('scrolled', !!this.scrollTop)
    },
  },
  mounted () {
    this.topSpacing = this.getTopSpacing()
    window.addEventListener('resize', this.handleResize)
    if (this.$listeners.scrolled) this.$el.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
    if (this.$listeners.scrolled) this.$el.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    getTopSpacing () {
      return this.$refs.scrollContainer.getBoundingClientRect().top
    },
    handleResize: _throttle(function () {
      this.topSpacing = this.getTopSpacing()
    }, 500),
    handleScroll: _throttle(function () {
      this.scrollTop = this.$el.scrollTop
    }, 200),
  },
}
</script>
